import React, { useEffect } from "react";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import FormLabel from "@mui/material/FormLabel";
import Grid from "@mui/material/Grid";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import dayjs from "dayjs";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { EducationAPI } from "../api";
import { selectUser } from "../../redux/modules/userSlice";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import useDraft from "../../hooks/useDraft";
import { toast } from "react-toastify";
import DraftSavedAt from "../Shared/DraftSavedAt";
import { pickSectionDraftData } from "../../drafts/draftHelpers";

function SectionC({ changeTab, handleButtonClick }) {
  const { user } = useSelector(selectUser);

  const initialState = [
    {
      userId: user.isAdmin ? id : user._id,
      qualification: "10th",
      fromDate: null,
      toDate: null,
      specialisedIn: "",
      university: "",
      registrationNo: "",
      result: "",
      collegeName: "",
    },
    {
      userId: user.isAdmin ? id : user._id,
      qualification: "12th/diploma",
      fromDate: null,
      toDate: null,
      specialisedIn: "",
      university: "",
      registrationNo: "",
      result: "",
      collegeName: "",
    },
    {
      userId: user.isAdmin ? id : user._id,
      qualification: "Graduation",
      fromDate: null,
      toDate: null,
      specialisedIn: "",
      university: "",
      registrationNo: "",
      result: "",
      collegeName: "",
    },
  ];

  const [qualifications, setQualifications] = useState([...initialState]);
  const params = useParams();
  const id = params.id ? params.id : "";
  const { loadDraft, saveDraft, deleteDraft, saving: draftSaving, lastDraftedAt } = useDraft(
    "newJoinee",
    "C",
  );
  const [newJoineeSectionCFlagButton, setNewJoineeSectionCFlagButton] =
    useState("");

  useEffect(() => {
    let isActive = true;

    (async () => {
      let draftApplied = false;

      if (!user.isAdmin) {
        const loadedDraft = await loadDraft();
        const draftData = loadedDraft && loadedDraft.data ? loadedDraft.data : null;
        const items =
          draftData &&
          draftData.qualifications &&
          Array.isArray(draftData.qualifications.qualifications)
            ? draftData.qualifications.qualifications
            : null;
        if (isActive && items && items.length > 0) {
          setQualifications([...items]);
          draftApplied = true;
        }
      }

      EducationAPI.getQualifications(user.isAdmin ? id : user._id)
        .then((res) => {
          if (!isActive) return;
          if (!draftApplied && res.data.length > 0) {
            setQualifications([...res.data]);
          }
          setNewJoineeSectionCFlagButton(
            res ? res.userData.isNewJoineeFormComplete : ""
          );
        })
        .catch((err) => {
          console.log(err);
        });
    })();

    return () => {
      isActive = false;
    };
  }, [id, loadDraft, user._id, user.isAdmin]);

  const handleSaveDraft = async () => {
    if (user.isAdmin) return;
    const wrapped = pickSectionDraftData("newJoinee", "C", { qualifications });
    const saved = await saveDraft(wrapped);
    if (saved && saved.skipped) {
      toast.info("Nothing to save as draft");
      return;
    }
    if (saved) toast.success("Draft saved");
    else toast.error("Unable to save draft");
  };

  const [validateerror, setvalidateerror] = useState();
  const [ackChecked, setAckChecked] = useState(false);
  const [ackError, setAckError] = useState(false);

  const sectionCErrorSelector =
    '[aria-invalid="true"], .Mui-error, [data-section-c-error="true"]';

  const isVisibleElement = (element) =>
    element &&
    (element.offsetWidth || element.offsetHeight || element.getClientRects().length);

  const scrollToSectionCError = (selector = sectionCErrorSelector) => {
    setTimeout(() => {
      let candidates = Array.from(document.querySelectorAll(selector));
      let target = candidates.find(isVisibleElement);

      if (!target && selector !== sectionCErrorSelector) {
        candidates = Array.from(document.querySelectorAll(sectionCErrorSelector));
        target = candidates.find(isVisibleElement);
      }

      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "center" });
        const focusTarget = target.matches(
          'input, textarea, button, [role="button"], [role="combobox"]',
        )
          ? target
          : target.querySelector(
              'input, textarea, button, [role="button"], [role="combobox"]',
            );
        if (focusTarget && typeof focusTarget.focus === "function") {
          focusTarget.focus({ preventScroll: true });
        }
      }
    }, 0);
  };

  const getFirstSectionCErrorSelector = (requiredErrors, missingAck) => {
    const requiredAt = (groupIndex, itemIndex) =>
      Boolean(
        requiredErrors &&
          requiredErrors[groupIndex] &&
          requiredErrors[groupIndex][itemIndex] &&
          requiredErrors[groupIndex][itemIndex].status,
      );

    const checks = [];
    qualifications.forEach((_, index) => {
      checks.push(
        {
          selector: `#sectionC-qualification-${index}`,
          invalid: requiredAt(0, index),
        },
        {
          selector: `#sectionC-fromDate-${index}`,
          invalid: requiredAt(1, index),
        },
        {
          selector: `#sectionC-toDate-${index}`,
          invalid: requiredAt(2, index),
        },
        {
          selector: `#sectionC-specialisedIn-${index}`,
          invalid: requiredAt(3, index),
        },
        {
          selector: `#sectionC-university-${index}`,
          invalid: requiredAt(4, index),
        },
        {
          selector: `#sectionC-registrationNo-${index}`,
          invalid: requiredAt(5, index),
        },
        {
          selector: `#sectionC-result-${index}`,
          invalid: requiredAt(6, index),
        },
      );
    });

    checks.push({
      selector: "#sectionC-acknowledgement",
      invalid: missingAck,
    });

    const firstError = checks.find((item) => item.invalid);
    return firstError ? firstError.selector : "";
  };

  const validatehandler = () => {
    const arr = [
      qualifications.map((e) => e.qualification),
      qualifications.map((e) => e.fromDate),
      qualifications.map((e) => e.toDate),
      qualifications.map((e) => e.specialisedIn),
      qualifications.map((e) => e.university),
      qualifications.map((e) => e.registrationNo),
      qualifications.map((e) => e.result),
    ];
    var arrName = [
      Array.from(qualifications, (e, i) => `qualifications${i}`),
      Array.from(qualifications, (e, i) => `fromDate${i}`),
      Array.from(qualifications, (e, i) => `toDate${i}`),
      Array.from(qualifications, (e, i) => `specialisedIn${i}`),
      Array.from(qualifications, (e, i) => `university${i}`),
      Array.from(qualifications, (e, i) => `registrationNo${i}`),
      Array.from(qualifications, (e, i) => `result${i}`),
    ];
    const keyObj = [];
    for (let i = 0; i < arr.length; i++) {
      let qualification = [];
      for (let j in arr[i]) {
        if (!arr[i][j]) {
          qualification.push({
            name: arrName[i][j],
            status: true,
          });
        } else {
          qualification.push({
            name: arrName[i][j],
            status: false,
          });
        }
      }
      keyObj.push(qualification);
    }
    setvalidateerror(keyObj);
    const arrData = [];
    for (let i in arr) {
      for (let j in arr[i]) {
        arrData.push(arr[i][j]);
      }
    }
    const check = arrData.every((e) => {
      if (Array.isArray(e)) {
        return e.every((x) => x);
      } else {
        return e;
      }
    });
    return {
      check,
      keyObj,
    };
  };

  const convertToCamelCase2 = (input) => {
    if (input === null || input.length === 0) {
      return input;
    }
    const words = input.split(" ");
    const camelCaseWords = words.map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });

    return camelCaseWords.join(" ");
  };

  const handleRegistrationChange = (e, index, field) => {
    const { value } = e.target;
    const camelCaseValue = convertToCamelCase2(value);
    const tempEducation = [...qualifications];

    if (field === "registrationNo" && value.length <= 15) {
      tempEducation[index][field] = camelCaseValue;
      setQualifications([...tempEducation]);
    }

    if (validateerror) {
      const validateChange = [...validateerror];
      if (field === "registrationNo" && validateChange[5][index]) {
        validateChange[5][index].status = false;
      }
      setvalidateerror(validateChange);
    }
  };

  const handleChange = (e, index, field) => {
    const { value } = e.target;
    let tempEducation = [...qualifications];
    tempEducation[index][field] = value;
    setQualifications([...tempEducation]);

    if (validateerror) {
      const validateChange = [...validateerror];

      if (field === "qualification" && validateChange[0][index]) {
        validateChange[0][index].status = false;
      }
      if (field === "specialisedIn" && validateChange[3][index]) {
        validateChange[3][index].status = false;
      }
      if (field === "university" && validateChange[4][index]) {
        validateChange[4][index].status = false;
      }
      setvalidateerror(validateChange);
    }
  };

  const handleResult = (e, index, field) => {
    const { value } = e.target;
    let tempEducation = [...qualifications];
    if (value <= 100) {
      tempEducation[index][field] = value;
      setQualifications([...tempEducation]);
    }

    if (validateerror) {
      const validateChange = [...validateerror];
      if (field === "result" && validateChange[6][index]) {
        validateChange[6][index].status = false;
      }
      setvalidateerror(validateChange);
    }
  };

  const handleDateChange = (e, index, field) => {
    let tempEducation = [...qualifications];

    let date = "";
    if (e) {
      let m = e.$d.getMonth() + 1;
      m = m < 10 ? `0${m}` : m;
      let d = ("0" + e.$D).slice(-2);
      date = e.$d.getFullYear() + "-" + m + "-" + d;

      tempEducation[index][field] = date;
      setQualifications([...tempEducation]);
    }
    if (validateerror) {
      const validateDate = [...validateerror];
      if (field === "fromDate" && validateDate[1][index]) {
        validateDate[1][index].status = false;
      }
      if (field === "toDate" && validateDate[2][index]) {
        validateDate[2][index].status = false;
      }

      setvalidateerror(validateDate);
    }
  };

  const addQualification = () => {
    let tempEducation = [...qualifications];
    tempEducation.push({
      userId: user._id,
      qualification: "",
      fromDate: null,
      toDate: null,
      specialisedIn: "",
      university: "",
      registrationNo: "",
      result: "",
      collegeName: "",
    });
    setQualifications([...tempEducation]);
  };

  const deleteQualification = async (index) => {
    let tempEducation = [...qualifications];
    if (tempEducation[index]._id) {
      EducationAPI.deleteQualifications(tempEducation[index]._id).catch(
        (err) => {
          console.log(err);
          return;
        }
      );
    }
    tempEducation.splice(index, 1);
    setQualifications([...tempEducation]);
  };

  const handleSubmit = () => {
    const validation = validatehandler();

    if (!validation.check) {
      const firstSelector = getFirstSectionCErrorSelector(
        validation.keyObj,
        false,
      );
      scrollToSectionCError(firstSelector || undefined);
      return;
    }

    if (!ackChecked) {
      setAckError(true);
      toast.error("Please acknowledge the details added by you are true", {
        hideProgressBar: true,
        closeOnClick: true,
      });
      scrollToSectionCError("#sectionC-acknowledgement");
      return;
    }

    handleButtonClick("sectionC");
    qualifications.map((history) => {
      if (history._id) {
        EducationAPI.updateQualifications(
          user.isAdmin ? id : history._id,
          history
        );
        return;
      } else {
        EducationAPI.createQualifications(history);
        return;
      }
    });
    // After official save, clear only Section C draft (if any).
    if (!user.isAdmin) deleteDraft();
    changeTab(3);
  };

  const handlechangeAll = () => {
    setQualifications(initialState);
  };

  return (
    <div>
      <div className={`col-12 ${user.isAdmin ? "" : "my-5"}`}>
        <div>
          <h3>
            <span>Educational Qualifications</span>
          </h3>
        </div>
        <div className="col-lg-12 col-md-12 col-sm-10">
          {qualifications.map((edu, index) => {
            return (
              <Box>
                <Grid container spacing={2} m={1}>
                  <Grid item>
                    <TextField
                      id={`sectionC-qualification-${index}`}
                      select
                      sx={{ width: "28ch" }}
                      label="Select Qualification"
                      value={edu.qualification}
                      error={
                        validateerror && validateerror[0][index]
                          ? validateerror[0][index].status
                          : ""
                      }
                      onChange={(e) => handleChange(e, index, "qualification")}
                      required
                      disabled={
                        index === 0 ||
                        index === 1 ||
                        index === 2 ||
                        (user.isAdmin &&
                          (newJoineeSectionCFlagButton === "pending" ||
                            newJoineeSectionCFlagButton === "submitted" ||
                            newJoineeSectionCFlagButton === "review done" ||
                            newJoineeSectionCFlagButton ===
                              "resubmission required"))
                      }
                    >
                      <MenuItem value="10th" disabled>
                        10th
                      </MenuItem>
                      <MenuItem value="12th/diploma" disabled>
                        12th/Diploma
                      </MenuItem>
                      <MenuItem value="Graduation" disabled>
                        Graduation
                      </MenuItem>
                      <MenuItem value="Masters">Masters</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid
                    item
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        sx={{ width: "22.5ch" }}
                        label="From"
                        value={edu.fromDate ? dayjs(edu.fromDate) : null}
                        onChange={(date) =>
                          handleDateChange(date, index, "fromDate")
                        }
                        format="DD/MM/YYYY"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            id={`sectionC-fromDate-${index}`}
                          />
                        )}
                        required
                        disabled={
                          user.isAdmin &&
                          (newJoineeSectionCFlagButton === "pending" ||
                            newJoineeSectionCFlagButton === "submitted" ||
                            newJoineeSectionCFlagButton === "review done" ||
                            newJoineeSectionCFlagButton ===
                              "resubmission required")
                        }
                      />
                    </LocalizationProvider>
                    <FormLabel
                      style={{
                        display:
                          validateerror &&
                          validateerror[1][index] &&
                          validateerror[1][index].status
                            ? ""
                            : "none",
                      }}
                      sx={{ color: "red" }}
                    >
                      (please select date)
                    </FormLabel>
                  </Grid>

                  <Grid
                    item
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        sx={{ width: "22.5ch" }}
                        label="To"
                        error={
                          validateerror && validateerror[2][index]
                            ? validateerror[2][index].status
                            : ""
                        }
                        format="DD/MM/YYYY"
                        value={edu.toDate ? dayjs(edu.toDate) : null}
                        onChange={(e) => handleDateChange(e, index, "toDate")}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            id={`sectionC-toDate-${index}`}
                          />
                        )}
                        required
                        disabled={
                          user.isAdmin &&
                          (newJoineeSectionCFlagButton === "pending" ||
                            newJoineeSectionCFlagButton === "submitted" ||
                            newJoineeSectionCFlagButton === "review done" ||
                            newJoineeSectionCFlagButton ===
                              "resubmission required")
                        }
                      />
                    </LocalizationProvider>
                    <FormLabel
                      style={{
                        display:
                          validateerror &&
                          validateerror[2][index] &&
                          validateerror[2][index].status
                            ? ""
                            : "none",
                      }}
                      sx={{ color: "red" }}
                    >
                      (please select date)
                    </FormLabel>
                  </Grid>
                  <Grid item>
                    <TextField
                      id={`sectionC-specialisedIn-${index}`}
                      fullWidth
                      sx={{ width: "28ch" }}
                      label="Specialised In"
                      value={edu.specialisedIn}
                      error={
                        validateerror && validateerror[3][index]
                          ? validateerror[3][index].status
                          : ""
                      }
                      onChange={(e) => handleChange(e, index, "specialisedIn")}
                      required
                      disabled={
                        user.isAdmin &&
                        (newJoineeSectionCFlagButton === "pending" ||
                          newJoineeSectionCFlagButton === "submitted" ||
                          newJoineeSectionCFlagButton === "review done" ||
                          newJoineeSectionCFlagButton ===
                            "resubmission required")
                      }
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      id={`sectionC-university-${index}`}
                      sx={{ width: "28ch" }}
                      fullWidth
                      label="Name of Board / University"
                      value={edu.university}
                      error={
                        validateerror && validateerror[4][index]
                          ? validateerror[4][index].status
                          : ""
                      }
                      onChange={(e) => handleChange(e, index, "university")}
                      required
                      disabled={
                        user.isAdmin &&
                        (newJoineeSectionCFlagButton === "pending" ||
                          newJoineeSectionCFlagButton === "submitted" ||
                          newJoineeSectionCFlagButton === "review done" ||
                          newJoineeSectionCFlagButton ===
                            "resubmission required")
                      }
                    />
                  </Grid>
                  {index !== 0 && index !== 1 ? (
                    <Grid item>
                      <TextField
                        sx={{ width: "34.5ch" }}
                        fullWidth
                        label="Name of college name"
                        value={edu.collegeName}
                        onChange={(e) => handleChange(e, index, "collegeName")}
                        required
                        disabled={
                          user.isAdmin &&
                          (newJoineeSectionCFlagButton === "pending" ||
                            newJoineeSectionCFlagButton === "submitted" ||
                            newJoineeSectionCFlagButton === "review done" ||
                            newJoineeSectionCFlagButton ===
                              "resubmission required")
                        }
                      />
                    </Grid>
                  ) : (
                    ""
                  )}
                  <Grid item>
                    <TextField
                      id={`sectionC-registrationNo-${index}`}
                      sx={{ width: "22.5ch" }}
                      fullWidth
                      label="Registration No"
                      value={edu.registrationNo}
                      error={
                        validateerror && validateerror[5][index]
                          ? validateerror[5][index].status
                          : ""
                      }
                      onChange={(e) =>
                        handleRegistrationChange(e, index, "registrationNo")
                      }
                      required
                      disabled={
                        user.isAdmin &&
                        (newJoineeSectionCFlagButton === "pending" ||
                          newJoineeSectionCFlagButton === "submitted" ||
                          newJoineeSectionCFlagButton === "review done" ||
                          newJoineeSectionCFlagButton ===
                            "resubmission required")
                      }
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      id={`sectionC-result-${index}`}
                      sx={{ width: "16ch" }}
                      fullWidth
                      label="Result (%/GPA)"
                      value={edu.result}
                      error={
                        validateerror && validateerror[6][index]
                          ? validateerror[6][index].status
                          : ""
                      }
                      onChange={(e) => handleResult(e, index, "result")}
                      required
                      disabled={
                        user.isAdmin &&
                        (newJoineeSectionCFlagButton === "pending" ||
                          newJoineeSectionCFlagButton === "submitted" ||
                          newJoineeSectionCFlagButton === "review done" ||
                          newJoineeSectionCFlagButton ===
                            "resubmission required")
                      }
                    />
                  </Grid>
                  {index > 2 ? (
                    <DeleteForeverIcon
                      onClick={() => deleteQualification(index)}
                      sx={{
                        color: "red",
                        cursor: "pointer",
                        marginLeft: "5px",
                        marginTop: "30px",
                      }}
                    />
                  ) : (
                    <> </>
                  )}
                </Grid>
                <hr />
              </Box>
            );
          })}
        </div>
        {/* <div className="col-12 ms-2 mb-4 border-bottom border-2"></div> */}
        <div className="col-12">
          <button
            onClick={() => addQualification()}
            type="button"
            className="btn btn-outline-primary"
            disabled={
              user.isAdmin &&
              (newJoineeSectionCFlagButton === "pending" ||
                newJoineeSectionCFlagButton === "submitted" ||
                newJoineeSectionCFlagButton === "review done" ||
                newJoineeSectionCFlagButton === "resubmission required")
            }
          >
            <span style={{ fontSize: "" }}>+ Add Qualification</span>
          </button>
        </div>
        <div className="col-12" style={{ marginTop: "110px" }}>
            {user.isAdmin ? (
              ""
            ) : (
            <div
              className="col-12 mb-2 px-3"
              id="sectionC-acknowledgement"
              data-section-c-error={ackError ? "true" : undefined}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={ackChecked}
                    onChange={(e) => {
                      setAckChecked(e.target.checked);
                      if (e.target.checked) setAckError(false);
                    }}
                  />
                }
                label="I acknowledge the details added by me are true"
              />
              {ackError && (
                <div style={{ color: "red", marginTop: "4px" }}>
                  Please acknowledge the details added by you are true.
                </div>
              )}
            </div>
          )}
          {newJoineeSectionCFlagButton === "review done" ||
          ((newJoineeSectionCFlagButton === "pending" ||
            newJoineeSectionCFlagButton === "submitted" ||
            newJoineeSectionCFlagButton === "resubmission required") &&
            user.isAdmin) ? (
            ""
          ) : (
            <div className="d-flex align-items-center">
              <div className="d-flex align-items-center">
                {!user.isAdmin && (
                  <button
                    onClick={() => handleSaveDraft()}
                    type="button"
                    className="btn btn-outline-primary btn-lg px-5 me-4"
                    disabled={draftSaving}
                  >
                    Save Draft
                  </button>
                )}
                <button
                  onClick={() => handleSubmit()}
                  type="button"
                  className="btn btn-primary btn-lg px-5 me-4"
                >
                  Save
                </button>
                <button
                  onClick={() => handlechangeAll()}
                  type="button"
                  className="btn btn-outline-primary btn-lg px-5"
                >
                  Clear All
                </button>
              </div>

              {!user.isAdmin ? (
                <DraftSavedAt className="ms-auto" date={lastDraftedAt} />
              ) : null}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SectionC;
